import styled from 'styled-components';

const getColor = {
  delay: {
    bgColor: '#FFEDE3',
    color: '#F0853D',
  },
  early: {
    bgColor: '#DEF3E1',
    color: '#69CA77',
  },
};

export const Tag = styled.span<{ status: string }>`
  color: ${(props) => getColor[props.status].color};
  background-color: ${(props) => getColor[props.status].bgColor};
  border-radius: 4px;
  padding: 4px;
`;
